package com.macrofocus.eflux.network.line

import org.locationtech.jts.geom.Geometry
import org.molap.dataframe.ListDataFrameBuilder

data class LineCoordinate(val logicalBranchId: String,
                          val seq: Int,
                          val coordinateId: String,
                          val logicalGeometry: Geometry,
                          val physicalGeometry: Geometry,
                          val risk_map: Int,
                          val risk_map_hex: String?,
                          val risk_list: String,
                          val logicalBranchIds: String,
                          val probability: Double?,
                          val details: String?,
                          val description: String?,
                          val t_70m: Double?,
                          val wind_speed_70m: Double?,
                          val wind_gusts_70m_1h: Double?,
                          val precip_5min: Double?,
                          val precip_type_intensity_5min: Double?,
                          val forest_fire_warning: Double?,
                          val power_line_oscillation_24h: Double?,
                          val weather_code_1h: Double?,
                          val tstorm_warning_1h: Double?,
                          val air_density_70m: Double?
) {
    companion object {
        val dataFrameBuilder: ListDataFrameBuilder<LineCoordinate, String>.() -> Unit = {
            "logicalBranchId" to { logicalBranchId }
            "seq" to { seq }
            "coordinateId" to { coordinateId }
            "logicalGeometry" to { logicalGeometry }
            "physicalGeometry" to { physicalGeometry }
            "risk_map" to { risk_map }
            "risk_map_hex" to { risk_map_hex }
            "risk_list" to { risk_list }
            "logicalBranchIds" to { logicalBranchIds }
            "probability" to { probability }
            "details" to { details }
            "description" to { description }
            "t_70m" to { t_70m }
            "wind_speed_70m" to { wind_speed_70m }
            "wind_gusts_70m_1h" to { wind_gusts_70m_1h }
            "precip_5min" to { precip_5min }
            "precip_type_intensity_5min" to { precip_type_intensity_5min }
            "forest_fire_warning" to { forest_fire_warning }
            "power_line_oscillation_24h" to { power_line_oscillation_24h }
            "weather_code_1h" to { weather_code_1h }
        }
    }
}